import React from 'react';
import { HeaderProgress } from '@gjensidige/se-header-progress';
import './HeaderWithStepManager.scss';

interface Props {
  topheaderText: string;
  firstRowText: string;
  secondRowText: string | string[];
  thirdRowText: string;
  statusJson: any;
}
export type ComponentProps = Props;
const HeaderWithStepManager: React.FC<ComponentProps> = (props) => {
  return (
    <>
      <HeaderProgress
        mainHeaderTxt={props.topheaderText}
        mainHeaderDescription={props.firstRowText}
        secondHeaderTxt={props.secondRowText}
        secondHeaderDescription={props.thirdRowText}
        steps={props.statusJson.steps}
        stepValue={props.statusJson.value}
      ></HeaderProgress>
    </>
  );
};
export default HeaderWithStepManager;
